const routes = [
  { name: "home", pattern: /^\/$/ },
  { name: "live", pattern: /^\/live\/?$/ },
  { name: "championships", pattern: /^\/comitati\/([A-Za-z0-9_-]+)\/campionati\/?$/, keys: ["committee"] },
  { name: "r2Compare", pattern: /^\/gironi\/(\d+)\/R2\/?$/i, keys: ["group"] },
  { name: "r2CompareStandings", pattern: /^\/gironi\/(\d+)\/classifica\/R2\/?$/i, keys: ["group"] },
  { name: "standings", pattern: /^\/gironi\/(\d+)\/classifica\/?$/, keys: ["group"] },
  { name: "calendar", pattern: /^\/gironi\/(\d+)\/?$/, keys: ["group"] },
];

export function resolveRoute(pathname = window.location.pathname) {
  for (const route of routes) {
    const match = pathname.match(route.pattern);
    if (!match) continue;
    const params = Object.fromEntries((route.keys || []).map((key, index) => [key, match[index + 1]]));
    return { name: route.name, params };
  }
  return { name: "notFound", params: {} };
}

export function navigate(href, replace = false) {
  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) {
    window.location.href = url.href;
    return;
  }
  history[replace ? "replaceState" : "pushState"]({}, "", `${url.pathname}${url.search}${url.hash}`);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
